class SearchForm extends HTMLFormElement {
  constructor() {
    super();
    
    this.$searchInput = this.querySelector('[data-search-input]');
    this.$resetBtn = this.querySelector('[data-search-reset]');
    this.hiddenClass = 'visually-hidden';

    // Bind events
    this.$searchInput.addEventListener('input', this.onInputChange.bind(this));
    this.$resetBtn.addEventListener('click', this.onInputReset.bind(this));
  }

  onInputChange(event) {
    const newValue = event.target.value;

    if (!newValue) {
      this.$resetBtn.classList.add(this.hiddenClass);
    } else {
      this.$resetBtn.classList.remove(this.hiddenClass);
    }
  }

  onInputReset(event) {
    event.preventDefault();
    event.stopPropagation();

    this.$searchInput.value = '';
    this.$searchInput.dispatchEvent(new Event('input'));
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm, { extends: 'form' });
}

